const API_BASE = '/api'

// Dekodiert HTML Entities: &ouml; → ö, &quot; → ", etc.
const decodeHTML = (html) => {
  const txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}

// Rekursiv dekodieren: geht durch Objekte/Arrays und dekodiert alle Strings
const decodeObject = (obj) => {
  if (typeof obj === 'string') {
    return decodeHTML(obj)
  }
  if (Array.isArray(obj)) {
    return obj.map(decodeObject)
  }
  if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = decodeObject(obj[key])
      return acc
    }, {})
  }
  return obj
}

export const apiService = {
  getPapers: async (limit = 200) => {
    const response = await fetch(`${API_BASE}/papers?limit=${limit}`)
    if (!response.ok) throw new Error('Failed to fetch papers')
    const data = await response.json()
    return decodeObject(data)
  },

  getPaper: async (id) => {
    const response = await fetch(`${API_BASE}/papers/${id}`)
    if (!response.ok) throw new Error('Failed to fetch paper')
    const data = await response.json()
    return decodeObject(data)
  },

  search: async (query) => {
    const response = await fetch(`${API_BASE}/search?q=${encodeURIComponent(query)}`)
    if (!response.ok) throw new Error('Failed to search')
    const data = await response.json()
    return decodeObject(data)
  },

  getStats: async () => {
    const response = await fetch(`${API_BASE}/stats`)
    if (!response.ok) throw new Error('Failed to fetch stats')
    const data = await response.json()
    return decodeObject(data)
  }
}